(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["avensai-creator-videos"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('avensai-creator-videos')) {
    customElements.define('avensai-creator-videos', class extends HTMLElement {
      connectedCallback() {
        if (this.abortController) return;
        this.abortController = new AbortController();
        const signal = this.abortController.signal;
        this.videos = Array.from(this.querySelectorAll('video'));
        this.querySelectorAll('.avensai-creators__cover').forEach((button) => {
          const video = this.querySelector(`[id="${button.getAttribute('aria-controls')}"]`);
          if (!video) return;
          button.hidden = false;
          button.addEventListener('click', () => {
            button.hidden = true;
            video.focus({ preventScroll: true });
            const playback = video.play();
            if (playback && typeof playback.catch === 'function') playback.catch(() => {});
          }, { signal });
          video.addEventListener('play', () => { button.hidden = true; }, { signal });
        });
        this.addEventListener('play', (event) => {
          if (!(event.target instanceof HTMLVideoElement)) return;
          document.querySelectorAll('avensai-creator-videos video').forEach((video) => {
            if (video !== event.target) video.pause();
          });
        }, { capture: true, signal });
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.videos.forEach((video) => video.pause());
        }, { signal });
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) entry.target.pause();
            });
          }, { threshold: 0 });
          this.videos.forEach((video) => this.observer.observe(video));
        }
      }
      disconnectedCallback() {
        if (this.videos) this.videos.forEach((video) => video.pause());
        if (this.observer) this.observer.disconnect();
        if (this.abortController) this.abortController.abort();
        this.abortController = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["avensai-taste-home"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  const button = event.target.closest('[data-fit-target]');
  if (!button) return;
  const section = button.closest('.av-fit');
  section.querySelectorAll('[data-fit-target]').forEach(function(tab) { tab.setAttribute('aria-pressed', String(tab === button)); });
  section.querySelectorAll('.av-fit-result').forEach(function(panel) { panel.hidden = panel.id !== button.dataset.fitTarget; });
});
const avMotionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
const avMotionObserver = new IntersectionObserver(function(entries) {
  entries.forEach(function(entry) {
    if (entry.isIntersecting && !avMotionPreference.matches) entry.target.play().catch(function() {});
    else entry.target.pause();
  });
}, {threshold: 0.3});
function observeAvMotion() { document.querySelectorAll('.av-motion-video').forEach(function(video) { avMotionObserver.observe(video); }); }
observeAvMotion();
document.addEventListener('shopify:section:load', observeAvMotion);
avMotionPreference.addEventListener('change', function() { if (avMotionPreference.matches) document.querySelectorAll('.av-motion-video').forEach(function(video) { video.pause(); }); });

  } catch(e) { console.error(e); }
})();
})();
